import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { AdmincrashreportService } from 'api/admincrashreport/admincrashreport.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'admincrashreport-page',
    templateUrl: './admincrashreport.html'
})
export class AdminCrashreport implements OnInit {
    crashList: any;
    message: any
    constructor(private AdmincrashreportService: AdmincrashreportService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'DEVELOPER' || localStorage.getItem('type') == 'SUPERCLIENT' || localStorage.getItem('type') == 'CLIENT')) {
            $(function () {
            })
            this.initData();
        } else {
            this.router.navigate(['/']);
        }
    }
    initData() {
        this.AdmincrashreportService.allAdmincrashreport().then(data => {
            if (data.status) {
                this.crashList = data.data
                if (data.data.length == 0) {
                    $.notify({
                        message: "Great, Your Code Work Perfect.No Crash Report Found"
                    },
                        {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                }
            }
        })
    }
    copyFile(val) {
        var v = JSON.stringify(val);
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = v;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
    Showdetails(crashes) {
        this.message = crashes.message
    }
    deleteSure() {
        this.AdmincrashreportService.deleteAdmincrashreport().then(data => {
            if (data.status) {
                this.crashList = []
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
                $(function () {
                    $('#deleteSureModal').modal('toggle');
                });
            } else {
                $.notify({
                    message: data.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        })
    }
    CreateBackup() {
        this.AdmincrashreportService.createBackup().then(data => {
            if (data.status) {
                $.notify({
                    message: "Backup Successfully Created."
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
            else {
                $.notify({
                    message: "Error Whilte Creating Backup."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/admincrashreport/admincrashreport.page.ts